import Crud from '../views/Monitoring/Crud'
//import View from '../views/Monitoring/View'


let routes = {
    path: '/monitorings',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
    
        {
            path: '/monitorings',
            name: 'list-monitorings',
            component: Crud,
            meta: {
                pageTitle: 'Dashboards',
                breadcrumb: [
                    {
                        text: 'Dashboards ',
                        active: true,
                    },
                ],
            },
        }
    ]
};

export default routes;
